import { render, staticRenderFns } from "./sceneryCateList.vue?vue&type=template&id=08a07f70&scoped=true&"
import script from "./sceneryCateList.vue?vue&type=script&lang=js&"
export * from "./sceneryCateList.vue?vue&type=script&lang=js&"
import style0 from "./sceneryCateList.vue?vue&type=style&index=0&id=08a07f70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a07f70",
  null
  
)

export default component.exports